import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import store from "./store";
import history from "./history";
import Layouts from "./layouts";
import { THEME_CONFIG } from "./configs/AppConfig";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { startVendorPushNotifications } from "services/VendorPushNotificationService";
import "./lang";
import WelcomePopup from "../src/views/app-views/components/welcomePopUp/WelcomePopup";

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function App() {
  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN);
    const storeId = localStorage.getItem("store_id");
    if (token && storeId) {
      startVendorPushNotifications().catch(() => {});
    }
  }, []);

  return (
    <div className="App">
      {/* <Provider store={store}> */}
      <BrowserRouter history={history}>
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <Layouts />
          {/* <WelcomePopup /> */}
        </ThemeSwitcherProvider>
      </BrowserRouter>
      {/* </Provider> */}
    </div>
  );
}

export default App;
